import { Injectable } from '@angular/core';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { TypeInfosRectif } from '../../models/TypeInfosRectif';

@Injectable({
  providedIn: 'root'
})
export class InfosRectifService {

  constructor() { }

  getInfosRectif(controls, formExtractorService): TypeInfosRectif[] {
    const infosRectif_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['Rectificatif'], '_SepSep_Rectificatif_index_');
    let infosRectif_iter = 0;

    const infosRectif = [];

    infosRectif_iters.forEach(() => {
      infosRectif[infosRectif_iter] = new TypeInfosRectif();
      const RB = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_RB');
      if (RB === RadioCheckBoxEnum.emptyValue) {
        infosRectif[infosRectif_iter].rubDelais = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_rubDelais');
        const lireDate = '_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_lireDate';
        infosRectif[infosRectif_iter].lireDate = controls.get(lireDate);
        const auLieuDeDate = '_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_auLieuDeDate';
        infosRectif[infosRectif_iter].auLieuDeDate = controls.get(auLieuDeDate);
        infosRectif[infosRectif_iter].auLieuDe = null;
        infosRectif[infosRectif_iter].rubrique = null;
        infosRectif[infosRectif_iter].apresLaMention = null;
        infosRectif[infosRectif_iter].lire = null;
        infosRectif[infosRectif_iter].supprimer = null;
        infosRectif[infosRectif_iter].ajouter = null;
      } else {
        infosRectif[infosRectif_iter].rubDelais = null;
        infosRectif[infosRectif_iter].lireDate = null;
        infosRectif[infosRectif_iter].auLieuDeDate = null;
        infosRectif[infosRectif_iter].rubrique = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_rubrique');

        infosRectif[infosRectif_iter].isALS= controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_ALS_RB');

        if (infosRectif[infosRectif_iter].isALS === RadioCheckBoxEnum.lire) {
          infosRectif[infosRectif_iter].lire = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_lire');
          infosRectif[infosRectif_iter].supprimer = null;
          infosRectif[infosRectif_iter].ajouter = null;
          infosRectif[infosRectif_iter].auLieuDe = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_auLieuDe');
          infosRectif[infosRectif_iter].apresLaMention = null;
        }
        if (infosRectif[infosRectif_iter].isALS === RadioCheckBoxEnum.ajouter) {
          infosRectif[infosRectif_iter].lire = null;
          infosRectif[infosRectif_iter].supprimer = null;
          infosRectif[infosRectif_iter].ajouter = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_ajouter');
          infosRectif[infosRectif_iter].auLieuDe = null;
          infosRectif[infosRectif_iter].apresLaMention = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_apresLaMention');
        }
        if (infosRectif[infosRectif_iter].isALS === RadioCheckBoxEnum.supprimer) {
          infosRectif[infosRectif_iter].lire = null;
          infosRectif[infosRectif_iter].supprimer = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_supprimer');
          infosRectif[infosRectif_iter].ajouter = null;
          infosRectif[infosRectif_iter].auLieuDe = null;
          infosRectif[infosRectif_iter].apresLaMention = controls.get('_SepSep_Rectificatif_index_' + (infosRectif_iter + 1) + '_SepSep_TypeInfosRectif_SepAtt_apresLaMention');
        }
      }

      infosRectif_iter++;
    });

    return infosRectif;
  }
}
